module.exports = __webpack_public_path__ + "static/img/fun5.9d2cad90.png";